import React, { useState } from "react";
import { ClipLoader } from "react-spinners";
import { Balance } from "../context/Context";
import { Navigate, useNavigate } from "react-router-dom";
import {
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { formatCurrency } from "./EnterBalance";
import { Button, Card, Form, Page, Text } from "@shopify/polaris";

function PaymentComponent({ storeID, amount }) {
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    setIsProcessing(true);

    try {
      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: "http://localhost:3000/success",
        },
        redirect: "if_required",
      });

      if (error) {
        if (error.type === "card_error" || error.type === "validation_error") {
          console.error(error);
          setMessage(error.message);
        } else {
          setMessage("An unexpected error occurred.");
        }
        setIsProcessing(false);
      } else {
        // Send request to top up to our backend
        const body = {
          increment: Math.round(formatCurrency(amount, "gbp") * 100),
          id: Number(storeID),
        };
        await fetch("https://backend.wecarrybags.co.uk/api/v1/shopify/top-up", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });
        navigate("/success");
      }
    } catch (error) {
      console.log("Error: ", error);
      setMessage(error);
    }
    setIsProcessing(false);
  };

  return (
    <Card>
      <Text variant="headingLg">Payment Page</Text>
      <div style={{ padding: 9 }} />
      <div className="w-full max-w-5xl mx-auto">
        {isProcessing && (
          <div
            className={`fixed inset-0 z-50 flex bg-black bg-opacity-40 items-center justify-center`}
          >
            <ClipLoader color="#FFFFFF" />
          </div>
        )}
        <Form
          id="payment-form"
          className="flex flex-col mx-auto "
          onSubmit={handleSubmit}
        >
          <PaymentElement options={{ layout: { type: "accordion" } }} />
          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              paddingTop: 9,
            }}
          >
            <Button submit={true} disabled={isProcessing}>
              Pay £{amount / 100} now
            </Button>
          </div>
          {message && <div id="payment-message">{message}</div>}
        </Form>
      </div>
    </Card>
  );
}

export default function Checkout() {
  const { clientSecret, stripePromise, storeID, amount } = Balance();

  const stripeIsInitialised =
    !!stripePromise && !!clientSecret && !!storeID && amount;

  if (!stripeIsInitialised) {
    return <Navigate to={"/not-found"} />;
  } else {
    return (
      <Page>
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <PaymentComponent storeID={storeID} amount={amount} />
        </Elements>
      </Page>
    );
  }
}
